import { Box, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { Controller } from 'react-hook-form';
import CustomTextField from '../../../commonComponents/CustomTextField';

const SearchFilters = ({ filterTag, handleChange, tags, MenuProps, control, debouncedHandleSearchChange }) => {
  return (
    <>
      <FormControl sx={{ width: 200 }}>
        <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          value={filterTag}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" sx={{ border: '1px solid #DCE4E8', borderRadius: '15px' }} />}
          renderValue={(selected) => {
            const selectedTag = tags.find((tag) => tag.value === selected[0]);
            return selectedTag ? selectedTag.label : '';
          }}
          MenuProps={MenuProps}
        >
          {tags.map((tag) => (
            <MenuItem key={tag.value} value={tag.value}>
              <ListItemText primary={tag.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Controller
        name="search"
        control={control}
        render={({ field: { onChange, value } }) => (
          <Box display="flex" flexDirection="column">
            <CustomTextField
              id="search"
              value={value ? value : ''}
              label="Search"
              onChange={(event) => {
                onChange(event);
                debouncedHandleSearchChange(event.target.value);
              }}
            />
          </Box>
        )}
      />
    </>
  );
};

export default SearchFilters;
